/**
 * Цена нажатия «Создать» и строка о жетонах в итоге выбора (ТЗ главной § 6, § 7 п. 2–3, § 10):
 * цена — на кнопке («Создать 2 карточки · 1 жетон»), в итоге — остаток после списания
 * («останется 3 жетона из 5»), «Без жетона · карточки уже готовы» или время новых жетонов.
 * Дневные кончились — списывается несгораемый жетон (с 2026-10-22). Один расчёт для
 * `WordSpotlight`, этапа 2 телефона и листа главной. Чистая функция без alias-импортов: поля
 * квоты описаны структурно.
 */

/** Квота на сегодня (`/me/quota`): только нужные итогу поля. */
export interface PriceQuota {
  remaining: number;
  dailyLimit: number;
  /** Несгораемые жетоны: тратятся, когда дневные закончились. */
  bonus: number;
  /** ISO UTC момента пополнения (00:00 МСК). */
  resetAt: string;
}

export type TokenLine =
  /** Ничего не выбрано или квота ещё грузится — строки нет. */
  | { kind: 'none' }
  /** Нужна генерация: сколько дневных останется после списания. */
  | { kind: 'left'; left: number; limit: number }
  /** Дневные закончились — спишется несгораемый: сколько их останется. */
  | { kind: 'bonus'; left: number }
  /** Всё выбранное уже готово — без жетона. */
  | { kind: 'free' }
  /** Жетоны закончились — новые в 00:00 МСК. */
  | { kind: 'out'; resetAt: string };

export interface ChoicePrice {
  /** Нажатие спишет жетон — цена на кнопке «· 1 жетон». */
  paid: boolean;
  /** Жетоны закончились, а в выборе есть генерация — кнопка неактивна «Жетоны закончились». */
  blocked: boolean;
  line: TokenLine;
}

/**
 * `count` — сколько карточек создастся (слово и каждая фраза), `needsGeneration` — хоть одно
 * значение без готовой карточки. Одно нажатие — одна генерация, поэтому цена всегда 1 жетон.
 */
export function choicePrice({
  count,
  needsGeneration,
  quota,
}: {
  count: number;
  needsGeneration: boolean;
  quota?: PriceQuota | null;
}): ChoicePrice {
  if (count <= 0) return { paid: false, blocked: false, line: { kind: 'none' } };
  if (!needsGeneration) return { paid: false, blocked: false, line: { kind: 'free' } };
  // Цена известна и без квоты; остаток покажем, когда она придёт.
  if (!quota) return { paid: true, blocked: false, line: { kind: 'none' } };
  if (quota.remaining <= 0) {
    if (quota.bonus > 0) return { paid: true, blocked: false, line: { kind: 'bonus', left: quota.bonus - 1 } };
    return { paid: true, blocked: true, line: { kind: 'out', resetAt: quota.resetAt } };
  }
  return {
    paid: true,
    blocked: false,
    line: { kind: 'left', left: Math.max(0, quota.remaining - 1), limit: quota.dailyLimit },
  };
}
